module.exports = __webpack_public_path__ + "img/ic-logo-localbank.542146a8.svg";